<template>
  <v-app-bar app class="app app-bar" dark height="95">
    <div class="schl_div">
      <v-img
        alt="School Logo"
        class="shrink mr-2 schl_logo"
        contain
        :src="org.logo"
        transition="scale-transition"
      />
    </div>

    <!-- <v-spacer></v-spacer> -->

    <v-btn
      href="https://edupluscampus.com/"
      target="_blank"
      text
      class="erp-logo hidden-sm-and-down"
    >
      <span class="mr-2">
        <v-img
          alt="School Logo"
          class="shrink mr-2 erp_logo"
          contain
          src="https://eduplusschool.s3.ap-south-1.amazonaws.com/eduplus_logo.jpeg"
          transition="scale-transition"
      /></span>
      <v-icon>mdi-open-in-new</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      org: {
        logo: "",
      },
    };
  },
  mounted() {
    axios
      .post("/login/login", {
        dns: window.location.hostname,
      })
      .then((res) => {
        if (res.data.msg == "200") {
          this.org.logo = res.data.logo;
          //this.trust_logo = res.data.trust_logo
          localStorage.setItem("EPS-org-logo", res.data.logo);
          localStorage.setItem("EPS-trust-logo", res.data.trust_logo);
          localStorage.setItem("is_mobile_signup", res.data.is_mobile_signup);
        } else {
          localStorage.setItem("EPS-org-logo", "");
          this.org.logo = "https://edupluscampus.com/img/logos/logo-white.png";
        }
      })
      .catch();
  },
};
</script>
<style scoped>
.app {
  background: #9575DE; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #9575DE,
    #9575DE,
    #9575DE
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #9575DE,
    #9575DE,
    #9575DE
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.erp_logo {
  width: 140px;
  height: 94px;
}
.erp-logo {
  margin-left: 70%;
}
.schl_div {
  background-color: white;
  margin-left: -10px;
}
.schl_logo {
  width: 140px;
  height: 94px;
}
@media (max-width: 920px) {
  .erp-logo {
    margin-left: 0;
  }

  body {
    overflow-x: hidden;
    width: 100%;
  }
  v-btn {
    width: 50% !important;
  }
  .app-bar {
    /* height: 70px !important; */
    width: 100% !important;
  }
}
</style>